import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Usage: data-controller="signature-modal"
// Handles signature modal with text input and output to specified element
export default class extends Controller {
  static targets = ["modal", "input", "insertBtn"];
  static values = {
    outputElementSelectors: Array
  };

  connect() {
    this.bootstrapModal = new Modal(this.modalTarget);
    
    // Reset input when modal is hidden
    this.modalTarget.addEventListener('hidden.bs.modal', this._handleModalHidden.bind(this));
  }

  disconnect() {
    this.modalTarget.removeEventListener('hidden.bs.modal', this._handleModalHidden.bind(this));
    this.bootstrapModal?.dispose();
  }

  open(event) {
    event?.preventDefault();
    this.bootstrapModal.show();
  }

  close() {
    this.bootstrapModal.hide();
  }

  onInput() {
    const hasValue = this.inputTarget.value.trim().length > 0;
    this.insertBtnTarget.disabled = !hasValue;
  }

  insertSignature(event) {
    event?.preventDefault();
    
    const signatureText = this.inputTarget.value.trim();
    if (!signatureText) return;

    this.outputElementSelectorsValue.forEach(selector => {
      const outputElement = document.querySelector(selector);
      if (outputElement) {
        if (outputElement.tagName === 'INPUT' || outputElement.tagName === 'TEXTAREA') {
          outputElement.value = signatureText;
          outputElement.dispatchEvent(new Event('input', { bubbles: true }));
        } else {
          outputElement.textContent = signatureText;
        }
        outputElement.classList.add('has-signature');
      }
    });

    this.close();
  }

  _handleModalHidden() {
    this.inputTarget.value = '';
    this.insertBtnTarget.disabled = true;
  }
}
